/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AlertesEmplacementDto } from '../models/alertes-emplacement-dto';
import { ConsommationAgregatDto } from '../models/consommation-agregat-dto';
import { getAlertTemperatureByDkCodesEmplacements } from '../fn/reportings-p-1-controller/get-alert-temperature-by-dk-codes-emplacements';
import { GetAlertTemperatureByDkCodesEmplacements$Params } from '../fn/reportings-p-1-controller/get-alert-temperature-by-dk-codes-emplacements';
import { getCategorieReportingP1ByIdInstallations } from '../fn/reportings-p-1-controller/get-categorie-reporting-p-1-by-id-installations';
import { GetCategorieReportingP1ByIdInstallations$Params } from '../fn/reportings-p-1-controller/get-categorie-reporting-p-1-by-id-installations';
import { getConsommations } from '../fn/reportings-p-1-controller/get-consommations';
import { GetConsommations$Params } from '../fn/reportings-p-1-controller/get-consommations';
import { getSitesAlertesTemperatureByDkCodesEmplacements } from '../fn/reportings-p-1-controller/get-sites-alertes-temperature-by-dk-codes-emplacements';
import { GetSitesAlertesTemperatureByDkCodesEmplacements$Params } from '../fn/reportings-p-1-controller/get-sites-alertes-temperature-by-dk-codes-emplacements';
import { getTdbDonneesInstallationP1 } from '../fn/reportings-p-1-controller/get-tdb-donnees-installation-p-1';
import { GetTdbDonneesInstallationP1$Params } from '../fn/reportings-p-1-controller/get-tdb-donnees-installation-p-1';
import { getTdbP1 } from '../fn/reportings-p-1-controller/get-tdb-p-1';
import { GetTdbP1$Params } from '../fn/reportings-p-1-controller/get-tdb-p-1';
import { getTdbP1DonneesSites } from '../fn/reportings-p-1-controller/get-tdb-p-1-donnees-sites';
import { GetTdbP1DonneesSites$Params } from '../fn/reportings-p-1-controller/get-tdb-p-1-donnees-sites';
import { getTemperaturesAmbiantes } from '../fn/reportings-p-1-controller/get-temperatures-ambiantes';
import { GetTemperaturesAmbiantes$Params } from '../fn/reportings-p-1-controller/get-temperatures-ambiantes';
import { InstallationCategorieReportingDto } from '../models/installation-categorie-reporting-dto';
import { SiteAlerteDto } from '../models/site-alerte-dto';
import { TdbP1DonneesInstallationResponseDto } from '../models/tdb-p-1-donnees-installation-response-dto';
import { TdbP1DonneesSitesResponseDto } from '../models/tdb-p-1-donnees-sites-response-dto';
import { TdbP1ResponseDto } from '../models/tdb-p-1-response-dto';
import { TemperatureAmbianteDto } from '../models/temperature-ambiante-dto';

/**
 * Récuperation des infos sur le reporting P1
 */
@Injectable({ providedIn: 'root' })
export class ReportingsP1ControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTdbP1()` */
  static readonly GetTdbP1Path = '/v1/reportings_p1/tdb';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTdbP1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTdbP1$Response(params: GetTdbP1$Params, context?: HttpContext): Observable<StrictHttpResponse<TdbP1ResponseDto>> {
    return getTdbP1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTdbP1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTdbP1(params: GetTdbP1$Params, context?: HttpContext): Observable<TdbP1ResponseDto> {
    return this.getTdbP1$Response(params, context).pipe(
      map((r: StrictHttpResponse<TdbP1ResponseDto>): TdbP1ResponseDto => r.body)
    );
  }

  /** Path part for operation `getTdbP1DonneesSites()` */
  static readonly GetTdbP1DonneesSitesPath = '/v1/reportings_p1/tdb/sites';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTdbP1DonneesSites()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTdbP1DonneesSites$Response(
    params: GetTdbP1DonneesSites$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<TdbP1DonneesSitesResponseDto>> {
    return getTdbP1DonneesSites(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTdbP1DonneesSites$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTdbP1DonneesSites(
    params: GetTdbP1DonneesSites$Params,
    context?: HttpContext
  ): Observable<TdbP1DonneesSitesResponseDto> {
    return this.getTdbP1DonneesSites$Response(params, context).pipe(
      map((r: StrictHttpResponse<TdbP1DonneesSitesResponseDto>): TdbP1DonneesSitesResponseDto => r.body)
    );
  }

  /** Path part for operation `getSitesAlertesTemperatureByDkCodesEmplacements()` */
  static readonly GetSitesAlertesTemperatureByDkCodesEmplacementsPath = '/v1/reportings_p1/sites_alertes/temperature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSitesAlertesTemperatureByDkCodesEmplacements()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSitesAlertesTemperatureByDkCodesEmplacements$Response(
    params: GetSitesAlertesTemperatureByDkCodesEmplacements$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<SiteAlerteDto>>> {
    return getSitesAlertesTemperatureByDkCodesEmplacements(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSitesAlertesTemperatureByDkCodesEmplacements$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSitesAlertesTemperatureByDkCodesEmplacements(
    params: GetSitesAlertesTemperatureByDkCodesEmplacements$Params,
    context?: HttpContext
  ): Observable<Array<SiteAlerteDto>> {
    return this.getSitesAlertesTemperatureByDkCodesEmplacements$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SiteAlerteDto>>): Array<SiteAlerteDto> => r.body)
    );
  }

  /** Path part for operation `getCategorieReportingP1ByIdInstallations()` */
  static readonly GetCategorieReportingP1ByIdInstallationsPath = '/v1/reportings_p1/categories';

  /**
   * post.
   *
   * Récupère les catégorie de reporting P1 pour un ensemble d'installations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCategorieReportingP1ByIdInstallations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCategorieReportingP1ByIdInstallations$Response(
    params: GetCategorieReportingP1ByIdInstallations$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<InstallationCategorieReportingDto>>> {
    return getCategorieReportingP1ByIdInstallations(this.http, this.rootUrl, params, context);
  }

  /**
   * post.
   *
   * Récupère les catégorie de reporting P1 pour un ensemble d'installations
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCategorieReportingP1ByIdInstallations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getCategorieReportingP1ByIdInstallations(
    params: GetCategorieReportingP1ByIdInstallations$Params,
    context?: HttpContext
  ): Observable<Array<InstallationCategorieReportingDto>> {
    return this.getCategorieReportingP1ByIdInstallations$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<Array<InstallationCategorieReportingDto>>): Array<InstallationCategorieReportingDto> =>
          r.body
      )
    );
  }

  /** Path part for operation `getAlertTemperatureByDkCodesEmplacements()` */
  static readonly GetAlertTemperatureByDkCodesEmplacementsPath = '/v1/reportings_p1/alertes_emplacements';

  /**
   * post.
   *
   * récupérer des alertes d’augmentation des températures ambiantes récentes (surchauffes) pour une liste d'emplacements
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAlertTemperatureByDkCodesEmplacements()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAlertTemperatureByDkCodesEmplacements$Response(
    params: GetAlertTemperatureByDkCodesEmplacements$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<AlertesEmplacementDto>> {
    return getAlertTemperatureByDkCodesEmplacements(this.http, this.rootUrl, params, context);
  }

  /**
   * post.
   *
   * récupérer des alertes d’augmentation des températures ambiantes récentes (surchauffes) pour une liste d'emplacements
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAlertTemperatureByDkCodesEmplacements$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAlertTemperatureByDkCodesEmplacements(
    params: GetAlertTemperatureByDkCodesEmplacements$Params,
    context?: HttpContext
  ): Observable<AlertesEmplacementDto> {
    return this.getAlertTemperatureByDkCodesEmplacements$Response(params, context).pipe(
      map((r: StrictHttpResponse<AlertesEmplacementDto>): AlertesEmplacementDto => r.body)
    );
  }

  /** Path part for operation `getTdbDonneesInstallationP1()` */
  static readonly GetTdbDonneesInstallationP1Path = '/v1/reportings_p1/tdb/installation/{dkCodeInstallation}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTdbDonneesInstallationP1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTdbDonneesInstallationP1$Response(
    params: GetTdbDonneesInstallationP1$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<TdbP1DonneesInstallationResponseDto>> {
    return getTdbDonneesInstallationP1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTdbDonneesInstallationP1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTdbDonneesInstallationP1(
    params: GetTdbDonneesInstallationP1$Params,
    context?: HttpContext
  ): Observable<TdbP1DonneesInstallationResponseDto> {
    return this.getTdbDonneesInstallationP1$Response(params, context).pipe(
      map((r: StrictHttpResponse<TdbP1DonneesInstallationResponseDto>): TdbP1DonneesInstallationResponseDto => r.body)
    );
  }

  /** Path part for operation `getTemperaturesAmbiantes()` */
  static readonly GetTemperaturesAmbiantesPath = '/v1/reportings_p1/t_ambiantes';

  /**
   * get.
   *
   * Récupère les données de températures ambiantes pour une installation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemperaturesAmbiantes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemperaturesAmbiantes$Response(
    params: GetTemperaturesAmbiantes$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<TemperatureAmbianteDto>>> {
    return getTemperaturesAmbiantes(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupère les données de températures ambiantes pour une installation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTemperaturesAmbiantes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemperaturesAmbiantes(
    params: GetTemperaturesAmbiantes$Params,
    context?: HttpContext
  ): Observable<Array<TemperatureAmbianteDto>> {
    return this.getTemperaturesAmbiantes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TemperatureAmbianteDto>>): Array<TemperatureAmbianteDto> => r.body)
    );
  }

  /** Path part for operation `getConsommations()` */
  static readonly GetConsommationsPath = '/v1/reportings_p1/consommations';

  /**
   * get.
   *
   * Récupère les données de températures ambiantes pour une installation
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConsommations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsommations$Response(
    params: GetConsommations$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ConsommationAgregatDto>> {
    return getConsommations(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupère les données de températures ambiantes pour une installation
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConsommations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConsommations(params: GetConsommations$Params, context?: HttpContext): Observable<ConsommationAgregatDto> {
    return this.getConsommations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConsommationAgregatDto>): ConsommationAgregatDto => r.body)
    );
  }
}
